export const siteSettings = {
  name: "Bloc Experts",
  link: "https://blocexperts.com",
  email: "support@blocexperts.com",
  appLink: "https://app.blocexperts.com",
};
